import { render } from "./LessonCard.vue?vue&type=template&id=4519b203&scoped=true"
import script from "./LessonCard.vue?vue&type=script&lang=js"
export * from "./LessonCard.vue?vue&type=script&lang=js"

import "./LessonCard.vue?vue&type=style&index=0&id=4519b203&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4519b203"]])

export default __exports__